module.exports = __webpack_public_path__ + "public/img/加入我们配图.7a4f3d67.png";